import Vuex from 'vuex'
import Vue from 'vue'
Vue.use(Vuex)

const lockersStore = new Vuex.Store({
  state: {
    lockers: [],
  },
  mutations: {
    fetchLockers(state, payload) {
      state.lockers = payload
    },
  },
  getters: {
    getLockers: function (state) {
      return state.lockers
    },
  },
})

export default lockersStore
